<template>
  <div>
    <b-breadcrumb :items="breads"></b-breadcrumb>
    <b-container fluid class="pl-lg-5 pr-lg-5">
      <b-row class="offset-1 col-10">
        <b-col lg="2" md="4" cols="12" class="border-right mh-600">
          <div class="px-3">
            <b-list-group flush>
              <b-list-group-item v-for="classify in classifies" :key="classify.id" :to="classify.link" :active="classify.active" class="rounded text-truncate">
                {{ classify.name }}
              </b-list-group-item>
            </b-list-group>
          </div>
        </b-col>
        <b-col lg="10" md="8" cols="12" v-show="prod">
          <product-detail v-bind="prod" @submit="onClickAddToCart"></product-detail>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import ProductDetail from './ProductDetail'
import { State } from '../library/EventBus'
export default {
  components: {
    ProductDetail
  },
  data () {
    return {
      prod: null,
      classifies: [],
      top: {},
      sub: {}
    }
  },
  computed: {
    pid () {
      return this.$route.params.id
    },
    breads () {
      const ary = [{ id: 'home', text: '首頁', to: '/' }]
      if (this.prod) {
        if (this.top) {
          const { id, name: text } = this.top
          ary.push({ id, text, to: `/classify/${id}` })
        }
        if (this.sub) {
          const { id: topId } = this.top
          const { id, name: text } = this.sub
          ary.push({ id, text, to: `/classify/${topId}/${id}` })
        }
        const { id, name: text } = this.prod
        ary.push({ id, text, to: `/prod/${id}` })
      }
      return ary
    },
    Cart () {
      return State.cart
    }
  },
  methods: {
    async start () {
      const { data } = await this.$api.getProd(this.pid)
      this.prod = data
      const { sub, top } = data
      this.sub = sub
      this.top = top
      await this.fetchSubClassify()
    },
    async fetchSubClassify () {
      const { id: topId } = this.top
      const { id: subId } = (this.sub || {})
      let list = []
      try {
        const { data } = await this.$api.getClassifySub(topId)
        data.sort((a, b) => a.sort - b.sort)
        list = data.map(item => {
          const { id, name } = item
          return { id, name, link: `/classify/${topId}/${id}`, active: subId === id }
        })
      } catch (err) {
        console.log(err)
      }
      list.unshift({
        id: 'all',
        name: '所有商品',
        link: `/classify/${topId}`,
        active: !list.find(item => item.active)
      })
      this.classifies = list
    },
    async onClickAddToCart (cargo, submit = false) {
      // find if in cargo
      const find = this.Cart.find(item => item.catalog === cargo.catalog && item.size === cargo.size)
      if (find) {
        cargo.amount += find.amount
      }
      await this.$api.postCart({ cargo })
      if (submit) {
        this.$router.push('/cart')
      }
      this.$bus.$emit('update:cart')
    }
  },
  mounted () {
    this.start()
  }
}
</script>
<style>
  @media (min-width: 576px)
  .mh-600 {
    min-height: 600px;
  }
  .breadcrumb {
	background: none;
    padding-left: 12.7%;
  }
  .list-group-item {
    background: #fefefe;
  }
  .list-group a.list-group-item {
    font-size: 1.1rem;
	border-width: 0;
	padding: .65rem 1.25rem;
  }
  @media (max-width: 1620px) {
  .breadcrumb {
    padding-left: 4.7%;
  }
  .offset-1 {
	margin-left: 0;
  }
  .col-10 {
	padding: 0;
	flex: unset;
    max-width: unset;
  }}
</style>